import { SetHeading } from "../../../context/NavbarContext";
import Sidebar from "../../../components/SideBar/sidebar";
import BasicDetails from "../../../components/Profile/BasicDetails";
import BusinessProof from "../../../components/Profile/BusinessProof";
import ChangePassword from "../../../components/Profile/ChangePassword";
import MySubscription from "../../../components/Profile/MySubscription";
import ShopDetails from "../../../components/Profile/ShopDetails";
import React, { useEffect, useState } from "react";
import image from "../../../assets/Images/roundimage.png";
import { Image } from "antd";
import { Breadcrumb } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import { routes } from "../../../Routes";
import { useSelector } from "react-redux";
import BDODetails from "../../../components/Profile/BDODetails";
import { store } from "../../../Redux/store";
import { useTranslation } from "react-i18next";
import "../../../styles.css";
import { GetRetailerDetails } from "../../../API  Functions/ProfileFunctions";
import ShopLocation from "../../../components/Profile/ShopLocation";
import BasicCashierSettings from "../../../components/CashierSetup/BasicCashierSettings";
import CashierModulesAccess from "../../../components/CashierSetup/CashierModulesAccess";
import DeliveryCompanySetup from "../../../components/CashierSetup/DeliveryCompanySetup";
import CashierReceiptFormat from "../../../components/CashierSetup/CashierReceiptFormat";
import OrderReceipt from "../../../components/CashierSetup/CashierReceiptFormat";

const CashierSetupScreen = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector((state) => state.login?.user?.store_id);
  const company_name = useSelector(
    (state) => state?.login?.user?.result?.company_name,
  );
  const image_url = useSelector(
    (state) => state?.login?.user?.result?.image_url,
  );
  const [retailerData, setretailerData] = useState({});
  const [selectedValue, setSelectedValue] = useState("Basic Settings");

  useEffect(() => {
    fetchdetails();
  }, []);

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setretailerData(result?.retailer_details);
      }
    });
  };

  const data = [
    {
      name: "Basic Settings",
      component: <BasicCashierSettings retailerDetails={retailerData} />,
    },
    {
      name: "Cashier Module Access",
      component: <CashierModulesAccess />,
    },
    {
      name: "Delivery Company Setup",
      component: <DeliveryCompanySetup retailerDetails={retailerData} />,
    },
    {
      name: "View Receipt Format",
      component: <OrderReceipt retailerDetails={retailerData} />,
    },
  ];
  //
  return (
    <div className="h-screen flex flex-col bg-[#F6F7F9]">
      <div className="sticky top-0 z-50 bg-[#F6F7F9]">
        <SetHeading value="Cashier Setup" />
      </div>

      <div className="flex-1 overflow-hidden px-1 md:px-3 mt-4 mb-4">
        <div className="bg-white rounded-xl h-full flex flex-col">
          <div className="sticky top-0 z-40 bg-white border-b px-4 py-3 flex gap-4 overflow-x-auto">
            {data.map((val, i) => (
              <div
                key={i}
                onClick={() => setSelectedValue(val.name)}
                className={`cursor-pointer px-4 py-2 rounded-md font-medium whitespace-nowrap transition-all
                ${
                  selectedValue === val.name
                    ? "bg-[#E6F0FF] text-[#1D4ED8] border border-[#1D4ED8]"
                    : "text-[#6B7280] hover:bg-gray-100"
                }`}
              >
                {t(val.name)}
              </div>
            ))}
          </div>

          <div className="flex-1 overflow-y-auto custom-scrollbar p-2 md:p-4">
            {data.map((val, i) => (
              <div
                key={i}
                className={val.name === selectedValue ? "block" : "hidden"}
              >
                {val.component}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashierSetupScreen;
